module.exports = __webpack_public_path__ + "img/check-badge.be4271f1.svg";